$('.grid__item.three-quarters li.mega-dropdown__item a').on('mouseenter', function() {
    $('.grid__item.three-quarters + .grid__item.one-quarter .rimage-outer-wrapper .rimage-wrapper img').css('opacity', '0');
    var data_image = $(this).attr('data_image');
    $('.grid__item.three-quarters + .grid__item.one-quarter .rimage-outer-wrapper .rimage-wrapper')
        .css({
            'background-image': 'url(' + data_image + ')',
            'background-size': 'cover',
            'background-position': 'center',
            'background-repeat': 'no-repeat'
        });
}).on('mouseleave', function() {
    $('.grid__item.three-quarters + .grid__item.one-quarter .rimage-outer-wrapper .rimage-wrapper img').css('opacity', '1');
    $('.grid__item.three-quarters + .grid__item.one-quarter .rimage-outer-wrapper .rimage-wrapper')
        .css('background-image', 'none');
});

$('button.btn--plain.feather-icon.mobile-site-nav__icon').click(function() {
    $('button.btn--plain.feather-icon.mobile-site-nav__icon.submenu-open.active').removeClass('active');
    $(this).addClass('active');
    $('button.btn--plain.feather-icon.mobile-site-nav__icon.submenu-open:not(.active)').click();
});

$('li.mobile-site-nav__item>.mega-mobile>.first_level_mobile.has_children .inactive_area').click(function() {
    $(this).closest('ul.nav.mobile-site-nav').addClass('open');
    $(this).closest('ul.nav.mobile-site-nav>li.mobile-site-nav__item').addClass('chosen');
    $(this).closest('li.mobile-site-nav__item>.mega-mobile>.first_level_mobile.has_children').next('ul.second_level_mobile').addClass('chosen');
    /*$('nav.navigation__container.full-width').animate({ scrollTop: 0 }, 'slow');*/
});

$('li.go_back').click(function() {
    $('ul.nav.mobile-site-nav').removeClass('open');
    $('ul.nav.mobile-site-nav>li.mobile-site-nav__item').removeClass('chosen');
    $('ul.second_level_mobile').removeClass('chosen');
});

$('._1wkq7nf9').attr("style", "bottom: 80px;right: 24px;");

// $(".add-to-cart-btn").click(function() {
//   setTimeout(function() {
//     $.ajax({
//       type: 'GET',
//       url: '/cart.js',
//       success: function(response) {
//         var cart = JSON.parse(response);
//         $('header-cart__count').html(cart.item_count);

//         // Fire Shopify Add-to-Cart Tracking
//         if (typeof window.ShopifyAnalytics !== 'undefined' && typeof window.ShopifyAnalytics.lib !== 'undefined') {
//           var item = cart.items.slice(-1)[0];
//           window.ShopifyAnalytics.lib.track('AddedToCart', {
//             id: item.variant_id,
//             quantity: item.quantity,
//             price: item.final_price / 100,
//             name: item.product_title,
//             variant: item.variant_title
//           });
//         }
//       }
//     });
//   }, 1000);
// });

// $(Document).ready(function() {
//     var learn_segment = $('a[href="#learn"]+.site-nav__dropdown > ul').clone();
//     $('.announcement-carousel-wrapper').one().after(learn_segment);
// });